<template>
    <div class="mb-3" :class="$attrs.class">
      <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
      <label v-else class="form-label" :for="id">Title:</label>
      <select :id="id" ref="input" v-model="selected" v-bind="{ ...$attrs, class: null }" class="form-select" :class="{ error: error }">
        <option value=""></option>
        <option value="Mr">Mr</option>
        <option value="Mrs">Mrs</option>
        <option value="Ms">Ms</option>
        <option value="Miss">Miss</option>
        <option value="Dr">Dr</option>
      </select>
      <div v-if="error" class="form-error">{{ error }}</div>
    </div>
  </template>

  <script>
  import { v4 as uuid } from 'uuid'

  export default {
    inheritAttrs: false,
    props: {
      id: {
        type: String,
        default() {
          return `select-input-${uuid()}`
        },
      },
      error: String,
      label: String,
      modelValue: [String, Number, Boolean],
    },
    emits: ['update:modelValue'],
    data() {
      return {
        selected: this.modelValue,
      }
    },
    watch: {
      selected(selected) {
        this.$emit('update:modelValue', selected)
      },
    },
    methods: {
      focus() {
        this.$refs.input.focus()
      },
      select() {
        this.$refs.input.select()
      },
    },
  }
  </script>
